import { CustomerMaritalStatus } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const maritalStatusMessages = defineMessages({
  divorced: {
    defaultMessage: 'Divorced',
    description: 'marital status title',
  },
  married: {
    defaultMessage: 'Married',
    description: 'marital status title',
  },
  single: {
    defaultMessage: 'Single',
    description: 'marital status title',
  },
  widowed: {
    defaultMessage: 'Widowed',
    description: 'marital status title',
  },
})

export function translateMaritalStatus(intl: IntlShape, status: CustomerMaritalStatus): string {
  switch (status) {
    case CustomerMaritalStatus.SINGLE:
      return intl.formatMessage(maritalStatusMessages.single)
    case CustomerMaritalStatus.MARRIED:
      return intl.formatMessage(maritalStatusMessages.married)
    case CustomerMaritalStatus.DIVORCED:
      return intl.formatMessage(maritalStatusMessages.divorced)
    case CustomerMaritalStatus.WIDOWED:
      return intl.formatMessage(maritalStatusMessages.widowed)
  }
}
